import deCH from '@/assets/data/translations/de-CH.json'
import frCH from '@/assets/data/translations/fr-CH.json'
import enUS from '@/assets/data/translations/en-US.json'

export default {
  'de-CH': deCH,
  'fr-CH': frCH,
  'en-US': enUS
}
